import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";
import Sidebar from "./Sidebar";
import { ClipLoader } from "react-spinners";

const MyProperties = () => {
  const [stays, setStays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔑 Token Handling
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const token = storedUser.accessToken || localStorage.getItem("accessToken");

  const isValidValue = (val) => {
  if (val === null || val === undefined) return false;

  const str = String(val).toLowerCase().trim();

  return !(str === "" || str === "0" || str === "na" || str === "null" || str === "undefined");
};

  useEffect(() => {
    const fetchStays = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}stays/owner/list`,
          { owner_id: storedUser?.id }, //. fetch only owner’s properties
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          const stayList = response.data.data || [];
          setStays(stayList);
        } else {
          setError(response.data.message || "Failed to fetch properties");
        }
      } catch (err) {
        console.error("Error fetching properties:", err);
        if (err.response?.status === 404) {
          setStays([]);
        } else if (err.response?.status === 401) {
          setError("Access token missing or invalid. Please login again.");
        } else {
          setError("Something went wrong while fetching properties");
        }
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchStays();
    } else {
      setError("User not logged in");
      setLoading(false);
    }
  }, [token, storedUser?.id]);

  // 🔄 Loading & Error States
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <ClipLoader size={45} />
      </div>
    );
  }
  if (error) return <p className="error-message">{error}</p>;

  return (
    <section className="profilecontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="profileinner">
              <div className="row">
                {/* Sidebar */}
                <Sidebar />
                {/* <aside className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-12 mb-3 mb-md-0">
                  <div className="profilenav">
                    <div className="profilenavbtm">
                      <ul>
                        <li>
                          <Link to="/owner-profile">My Profile</Link>
                        </li>
                        <li className="active">
                          <Link to="/my-properties">My Properties</Link>
                        </li>
                        <li>
                          <a
                            href="#logout"
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.clear();
                              window.location.href = "/login";
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside> */}

                {/* Main Content */}
                <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-9 col-sm-12 col-12">
                  <div className="profilerightouter">
                    <div className="dltabsview">
                      {/* Tabs */}
                      <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="Properties-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#Properties-tab-pane"
                            type="button"
                            role="tab"
                            aria-controls="Properties-tab-pane"
                            aria-selected="true"
                          >
                            My Properties
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <Link
                            to="/upload-property"
                            className="nav-link active"
                            role="tab"
                            aria-controls="Properties-tab-pane"
                            aria-selected="true"
                            state={{ addnewproperties: true }}
                          >
                            Add Properties
                          </Link>
                        </li>
                      </ul>

                      {/* Tab Content */}
                      <div
                        className="tab-content"
                        id="myTabContent"
                      >
                        {/*. Properties Tab */}
                        <div
                          className="tab-pane fade show active"
                          id="Properties-tab-pane"
                          role="tabpanel"
                          aria-labelledby="Properties-tab"
                          tabIndex="0"
                        >
                          <div className="tabinner">
                            {stays.length === 0 ? (
                              <div className="text-center py-5">
                                <h4 className="fw-bold">No Properties Added Yet!</h4>
                                <p className="text-muted mb-3">
                                  You don’t have any listed properties yet. Add your first property to start hosting.
                                </p>
                                <Link to="/upload-property" className="theme-btn">
                                  Add Property
                                </Link>
                              </div>
                            ) : (
                              stays.map((stay) => (
                                <div
                                  className="triplist"
                                  key={stay.id}
                                >
                                  {/* Room Image */}
                                  {/* Left Side */}
                                  <div className="triplistlt d-flex flex-column flex-lg-row gap-3 w-100">
                                    {stay?.cover_image?.length > 0 && (
                                      <div className="triplistimg">
                                        <img
                                          src={stay.cover_image}
                                          alt={"Room Image"}
                                        />
                                      </div>
                                    )}
                                    <div className="flex-fill">
                                      <h5>
                                        <Link to={`/property/${stay.id}`}>
                                          {stay.title || "--"}
                                        </Link>
                                      </h5>
                                      <p className="mb-1">
                                        <strong>Address:</strong> {stay.address || "--"}
                                      </p>
                                      <p className="mb-1">
                                        <strong>Location:</strong>{" "}
                                        {/* {stay.location_name || "--"} */}
                                        {isValidValue(stay.location_name) ? stay.location_name : "--"}
                                      </p>
                                      {/* <p className="mb-1">
                                        <strong>Price/Night:</strong> ₹
                                        {stay.price_per_night
                                          ? parseFloat(stay.price_per_night).toLocaleString()
                                          : 0}
                                      </p> */}

                                      {/* <p className="mb-1">
                                        <strong>Price Per Night From:</strong> ₹
                                        {stay?.rooms?.length
                                          ? Math.min(
                                            ...stay.rooms
                                              .map(room => Number(room.price_min))
                                              .filter(price => !isNaN(price))
                                          ).toLocaleString()
                                          : 0}
                                      </p> */}
                                      <p className="mb-1">
                                        <strong>Status:</strong>{" "}
                                        {stay.is_active ? "Active" : "Inactive"}
                                      </p>
                                      <p className="mb-1">
                                        <strong>Admin Approved:</strong>{" "}
                                        <span className={stay.is_aprrove ? "text-success fw-semibold" : "text-danger fw-semibold"}>
                                          {stay.is_aprrove ? "Yes" : "No"}
                                        </span>
                                      </p>

                                      {!stay.is_aprrove && (
                                        <div
                                          className="alert alert-danger d-flex align-items-center py-2 px-3"
                                          role="alert"
                                          style={{ fontSize: "13px" }}
                                        >
                                          <i className="bi bi-info-circle-fill me-2"></i>
                                          <span>
                                            <strong>Note:</strong> Until admin approval, your stay will not be listed on the user side.
                                          </span>
                                        </div>
                                      )}


                                    </div>
                                  </div>

                                  {/* Right Side */}
                                  <div className="triplistrt">
                                    {/* <Link
                                      to={`/property/${stay.id}`}
                                      className="theme-btn"
                                    >
                                      View Property
                                    </Link> */}
                                    <Link
                                      to={`/upload-property?id=${stay.id}`}
                                      className="theme-btn"
                                    >
                                      View Property
                                    </Link>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyProperties;
